// 消息推送
export default {
    createTime: 'время создания',
    startTime: 'Дата начала',
    endTime: 'Дата окончания',
    to: 'к',
    title: 'заглавие',
    titleSeach: 'Запрос заголовка',
    founder: 'основатель',
    pushModel: 'толкающий режим',
    pushTime: 'время нажатия',
    receiver: 'Получатель',
    priority: 'приоритет',
    messageContent: 'Содержание сообщения',
    operate: 'действовать',
    detail:'Подробности',
    newMessagePush:' Push нового сообщения',
    urgent: 'Срочный',
    high: 'высоко',
    middle: 'середина',
    low: 'Низкий',
    single: 'Один',
    timing: 'выбор времени',
    cycle: 'цикл',
    all:'все',
    sendTime: 'отправить время',
    interval: 'интервал',
    minute: 'минута',
    names: 'имя',
    mobilePhone: 'мобильный телефон',
    messagePushDetails:' Детали push-сообщения',
    pleaseEnter: 'Пожалуйста входите',
    plEnterTitle: 'Пожалуйста, введите название',
    plenterMessageCount: 'Пожалуйста, введите содержание сообщения',
    selectPriority: 'Выберите приоритет',
    selectPushModel: 'Пожалуйста, выберите режим отправки',
    selectTime: 'Пожалуйста, выберите время',
    selectInterval: 'Пожалуйста, выберите интервал',
    selectReceiver: 'Пожалуйста, выберите получателя',
    delOperate: 'Если сообщение удалено, его невозможно восстановить, будьте осторожны!',
    select: 'пожалуйста, выберите',
    nameSeach: 'запрос имени',
    addDepartment: 'Добавить отдел',
    department: 'отделение',
    license: 'лицензия',
    name: 'Имя',
    liceseType: 'Тип лицензии',
    personal: 'личный',
    resetDepart: 'Этот отдел уже существует! Пожалуйста, выберите другой отдел',
    selectHasuserdepart: 'Выберите отдел с пользователями',
}
